import { LEADS_FILTERS } from "features/leads/constants";
import useLeadsSearchParams from "features/leads/hooks/useLeadsSearchParams";
import type { LeadsSearchParams } from "features/leads/types";

import SearchInputFilter from "../../Filters/SearchInputFilter";
import SelectionTags from "./SelectionTags";
import TypeaheadValues from "./TypeaheadValues";

import type { FiltersProps } from "./FiltersSelection";

interface FilterProps extends FiltersProps {
  searchKey: keyof Omit<LeadsSearchParams<never>, "keywords" | "favorite">;
}

export default function Filter({
  searchKey,
  searchParams,
  setSearchParams,
}: FilterProps) {
  const { toggleSearchParam } = useLeadsSearchParams(
    searchParams,
    setSearchParams,
  );

  const selectedFacets = searchParams[searchKey];
  const { label } = LEADS_FILTERS[searchKey];

  return (
    <SearchInputFilter
      label={label}
      renderTagsComponent={(resetInputValue) =>
        selectedFacets.length ? (
          <SelectionTags
            searchKey={searchKey}
            selection={selectedFacets}
            onRemoveFilter={(facet) => {
              toggleSearchParam(searchKey, facet);
              resetInputValue();
            }}
          />
        ) : null
      }
    >
      {(query) => (
        <TypeaheadValues
          searchKey={searchKey}
          query={query}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      )}
    </SearchInputFilter>
  );
}
